<body>
    <ul>
        <div>
            <input type="file" (change)="onFileSelected($event)">
            <button *ngIf="jsonData" class="data-save-btn" (click)="salvarNoBanco(jsonData)">Data Save</button>

            <div *ngIf="showProgressBar">
                <progressbar [value]="progressValue" [max]="maxValue">{{ progressValue }} Saved lines</progressbar>
            </div>

            <a #downloadLink style="display: none;"></a>
            <div *ngIf="dataLoaded && jsonData">
                <p>Total lines {{ jsonData.length }}</p>
                <table>
                    <thead>
                        <tr>
                            <th>
                                <button (click)="sortBy('remessa')">Remessa</button>
                            </th>
                            <th>
                                <button (click)="sortBy('idContainer')">Container</button>
                            </th>
                            <th>
                                <button (click)="sortBy('Process')">Transportador</button>
                            </th>
                            <th>
                                <button (click)="sortBy('Plate')">Placa</button>
                            </th>
                            <th>
                                <button (click)="sortBy('janela')">Janela</button>
                            </th>
                            <th>
                                <button (click)="sortBy('linner')">Linner</button>
                            </th>
                            <th>
                                <button (click)="sortBy('booking')">Booking</button>
                            </th>
                            <th>
                                <button (click)="sortBy('observacoes')">Observações</button>
                            </th>

                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of jsonData; let i = index">
                            <td>{{ item.remessa }}</td>
                            <td>{{ item.idContainer }}</td>
                            <td>{{ item.Transportadora }}</td>
                            <td>{{ item.Plate }}</td>
                            <td>{{ item.Janela | date : 'dd/MM/yyyy HH:mm' : '+00:00' }}</td>
                            <td>{{ item.linner }}</td>
                            <td>{{ item.booking }}</td>
                            <td>{{ item.observacoes }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </ul>
</body>
<div *ngIf="isLoading" class="spinner-overlay">
    <div class="spinner">
        <mat-spinner></mat-spinner>
    </div>
</div>

<div *ngIf="mensagemAviso" class="alerta">
    {{ mensagemAviso }}
  </div>